<template>
  <div class="wrapper">
    <div class="close-btn" @click="close">
      <Icon class="icon" :fill="'#719192'" :width="'20px'" :height="'20px'" :name="'close'"/>
    </div>
    <p class="login-title">Forgot password</p>
    <div v-if="phoneAuth">
    <!-- <div v-if="false"> -->
      <form>
        <input type="text" v-model="phone" placeholder="email address"/><br/>
        <input class="vcodeInput" type="text" v-model="verCode" placeholder="code"/>
        <p class="verCode" ref="smsbtn" @click="sendCode">Send</p><br/>
        <div class="footer">
          <p class="button" @click.prevent="nextStep">Next</p>
        </div>
      </form>
    </div>
    <div v-if="newPwd">
    <!-- <div v-if="true"> -->
      <input type="password" v-model="pwd" placeholder="new password"/><br/>
      <input type="password" v-model="cpwd" placeholder="confirm new password"/><br/>
      <div class="footer">
        <p class="button" @click.prevent="commit">Change</p>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from '@/components/Reusables/Icon'
import {FindPwd, SmsFindPwd, CheckFindPwd} from '@/api/index.js'
export default {
  name: 'ForgotPassword',
  components:{
    Icon,
  },
  data() {
    return {
      phoneAuth:true,
      newPwd:false,
      phone:null,
      verCode:null,
      pwd:null,
      cpwd:null,
    };
  },
  methods:{
    commit(){
      if(this.pwd != this.cpwd){
        window.alert("confirm password doesn't match with your password!");
        return;
      }
      if(!this.pwd || !this.cpwd){
        window.alert("pls fill the blank form");
        return;
      }
      FindPwd({'code':this.verCode,'email':this.phone,'pass':this.pwd}).then(res => {
        window.alert('success!');
        this.$router.push({path:'/login'})
      })
    },
    sendCode(){
      if(this.sended)
        return false;

      let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(!reg.test(this.phone)){
        window.alert('email address not valid!');
        return;
      }
      SmsFindPwd({'email':this.phone}).then(res=>{
        this.sended = true;
        localStorage.setItem('countDown', null);
        this.sendCountdown();
      })
    },
    sendCountdown(){
      let sendBtn = this.$refs.smsbtn;
      let time = parseInt(localStorage.getItem('countDown')) || 60;
      let that = this;
      sendBtn.innerHTML = time + 's to resend';
      let myInterval = window.setInterval(function(){
        if(time <= 0){
          time = 60;
          localStorage.setItem('countDown', null);
          localStorage.setItem('countTime', null);
          that.sended = false;
          sendBtn.innerHTML = 'Send';
          window.clearInterval(myInterval);
          return;
        }

        time --;
        sendBtn.innerHTML = time + 's to resend';
        localStorage.setItem('countDown', time);
        localStorage.setItem('countTime', new Date().getTime());
      }, 1000);
    },
    close(){
      this.$store.commit('setCred', null)
    },
    nextStep(){
      if(!this.verCode){
        window.alert('please insert the verication code');
        return;
      }
      CheckFindPwd({'code':this.verCode,'email':this.phone}).then(res => {
        this.phoneAuth = false;
        this.newPwd = true;
      })
    }
  },
};
</script>
<style lang="" scoped>
@import './Reusables/cred.css';
.wrapper{
  width: calc(480px - 60px);
  height: calc(580px - 60px);
  padding: 30px;
}
input[type="text"],input[type="password"]{
  border: 0;
  background: transparent;
  border-bottom: 4px solid #719192;
  width: 100%;
  font-size: 22px;
  padding-bottom: 10px;
  margin-bottom: 40px;
  color: #719192;
}
input:focus{
  outline: none;
  /* border-color: red; */
}
.login-title{
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 50px;
  color: #719192;
}
.button{
  background: #719192;
  width: 100%;
  text-align: center;
  font-size: 32px;
  padding: 13px 0;
  color: #fff;
  border-radius: 10px;
  margin-top: 10px;
}
.button:hover{
  cursor: pointer;
  opacity: 0.8;
  color:#fff;
}
.closelogin{
  float:right;
  margin:10px 30px 0 0
}
.closelogin:hover{
  cursor: pointer;
}
.forgotpwd,.register{
  font-size: 16px;
  margin:0;
  margin-bottom: 10px;
}
.forgotpwd:hover,.register:hover{
  text-decoration: underline;
  cursor: pointer;
}
.vcodeInput{
  width: 45%!important;
  display: inline-block;
}
.verCode{
  display: inline-block;
  /* background: lavender; */
  margin-left:2%;
  /* width: 12%; */
  padding:10px 10px;
  border-radius: 10px;
  font-size: 13px;
  color:#fff;
  background: #719192;
  text-align: center;
}
.verCode:hover{
  cursor: pointer;
  opacity: 0.8;
  color:#fff;
}
@media screen and (max-width: 900px){
  .login-page{
    width: 70%;
    max-width: 450px;
    min-width: 220px;
    padding:50px 30px 0px;
    margin-top: 120px;
  }
  input[type="text"], input[type="password"]{
    width: 90%;
    border-radius: 0;
    border-bottom: 3px solid #719192;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue